<script lang="ts">
  import { Link, navigate } from 'svelte-routing';
  import { api } from '../../lib/api/client';
  import { isAuthenticated } from '../../lib/stores/auth';
  import PageHeader from '../../lib/components/PageHeader.svelte';
  import WeekSection from '../../lib/components/activities/WeekSection.svelte';
  import GoalsSection from '../../lib/components/activities/GoalsSection.svelte';
  import TilesSection from '../../lib/components/activities/TilesSection.svelte';
  import TrainingLog from '../../lib/components/activities/TrainingLog.svelte';
  import MonthlySection from '../../lib/components/activities/MonthlySection.svelte';
  import RecordsSection from '../../lib/components/activities/RecordsSection.svelte';
  import TrainingLoadSection from '../../lib/components/activities/TrainingLoadSection.svelte';
  import YearCalendar from '../../lib/components/activities/YearCalendar.svelte';
  import { calendar, type Goal, type Tiles } from '../../lib/utils/insights';
  import { t } from '../../lib/i18n/index.ts';

  // Progress is the viewer's own: This week with its comparison of the last
  // 3 months against the 3 before, goals, tiles, the training log, and
  // Monthly activities (spec 006 FR-059, spec 006 FR-056), then
  // Records, Training load, the year calendar, and the heatmap's button
  // (spec 006).

  $effect(() => {
    if (!$isAuthenticated) navigate('/login', { replace: true });
  });

  let goals = $state<Goal[]>([]);
  let tiles = $state<Tiles | null>(null);
  function loadGoals() {
    api.get<Goal[]>(`/me/goals?${calendar()}`).then((g) => (goals = g)).catch(() => {});
  }
  loadGoals();
  api.get<Tiles>(`/me/tiles?${calendar()}`).then((got) => (tiles = got)).catch(() => {});

  let logDay = $state<{ day: string } | null>(null);
</script>

<div class="p-6 max-w-4xl w-full mx-auto space-y-6">
  <Link to="/activities" class="text-sm hover:opacity-80"><i aria-hidden="true" class="las la-arrow-left mr-1"></i>{t('activitiesMine')}</Link>
  <PageHeader title={t('activitiesProgress')}>
    <Link to="/activities/heatmap" class="btn btn-secondary btn-sm inline-flex items-center gap-1"><i aria-hidden="true" class="las la-fire"></i>{t('activitiesHeatmap')}</Link>
  </PageHeader>
  <WeekSection onweek={(day) => (logDay = { day })} />
  <GoalsSection {goals} onchange={loadGoals} />
  {#if tiles}
    <TilesSection {tiles} {goals} onchange={(next) => (tiles = next)} onday={(day) => (logDay = { day })} />
  {/if}
  <TrainingLog show={logDay} />
  <MonthlySection />
  <RecordsSection />
  <TrainingLoadSection />
  <YearCalendar onmoving={(day) => (logDay = { day })} />
  <p class="text-xs text-text-muted">{t('activitiesProgressPrivate')}</p>
</div>
